// @ts-nocheck
import * as types from '../types';

const initialState = {
    playerDetails: null,
    playerSegments: {
        list: [],
        current: null,
        filters: {
            keyword: '',
        },
    },
    playerSegmentsReport: {
        list: [],
    },
    financialTransactions: {
        summary: {
            items: [],
            total: {},
        },
        detailed: [],
        pendingWithdrawals: [],
        kpi: {},
    },
    playerProfitsAndLosses: {
        byBetType: {
            items: [],
            summary: {},
        },
        byClientType: {
            items: [],
            summary: {},
        },
        byLeagueType: {
            items: [],
            summary: {},
        },
        byMarketName: {
            items: [],
            summary: {},
        },
        byProducerType: {
            items: [],
            summary: {},
        },
        bySportType: {
            items: [],
            summary: {},
        },
    },
    paymentAccounts: [],
    documents: [],
    communications: {
        messages: {
            allThreads: [],
            selectedThreads: {},
        },
        modalProps: {
            isVisible: false,
            shouldRefreshData: false,
            selectedThreadId: null,
        },
    },
    notes: {
        list: [],
        selected: null,
        modalProps: {
            isVisible: false,
            viewOnly: false,
            shouldRefreshData: false,
        },
    },
    passwordModalProps: {
        isVisible: false,
    },
    informationModalProps: {
        isVisible: false,
    },
    manualPaymentModalProps: {
        isVisible: false,
        type: null,
    },
    depositLimits: [],
    selfExclusion: {},
    giveBonusModalProps: {
        isVisible: false,
    },
    manualSegmentModalProps: {
        isVisible: false,
    },
};

const player = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case types.PLAYER_DETAILS_CHANGED: {
            return {
                ...state,
                playerDetails: payload,
            };
        }
        case types.PLAYER_DETAILS_CLEARED: {
            return {
                ...state,
                playerDetails: initialState.playerDetails,
            };
        }
        case types.PLAYER_SEGMENT_LIST_CHANGED: {
            return {
                ...state,
                playerSegments: {
                    ...state.playerSegments,
                    list: payload,
                },
            };
        }
        case types.PLAYER_SEGMENT_LIST_CLEARED: {
            return {
                ...state,
                playerSegments: {
                    ...state.playerSegments,
                    list: initialState.playerSegments.list,
                },
            };
        }
        case types.PLAYER_SEGMENT_CURRENT_CHANGED: {
            return {
                ...state,
                playerSegments: {
                    ...state.playerSegments,
                    current: payload,
                },
            };
        }
        case types.PLAYER_SEGMENT_CURRENT_CLEARED: {
            return {
                ...state,
                playerSegments: {
                    ...state.playerSegments,
                    current: initialState.playerSegments.current,
                },
            };
        }
        case types.PLAYER_SEGMENT_NAME_FILTER_CHANGED: {
            return {
                ...state,
                playerSegments: {
                    ...state.playerSegments,
                    filters: payload,
                },
            };
        }
        case types.PLAYER_SEGMENT_REPORT_CHANGED: {
            return {
                ...state,
                playerSegmentsReport: {
                    ...state.playerSegmentsReport,
                    list: payload,
                },
            };
        }

        case types.PLAYER_SEGMENT_REPORT_CLEARED: {
            return {
                ...state,
                playerSegmentsReport: {
                    ...state.playerSegmentsReport,
                    list: initialState.playerSegmentsReport.list,
                },
            };
        }

        case types.PLAYER_FINANCIAL_TRANSACTIONS_SUMMARY_CHANGED: {
            return {
                ...state,
                financialTransactions: { ...state.financialTransactions, summary: payload },
            };
        }
        case types.PLAYER_FINANCIAL_TRANSACTIONS_SUMMARY_CLEARED: {
            return {
                ...state,
                financialTransactions: {
                    ...state.financialTransactions,
                    summary: initialState.financialTransactions.summary,
                },
            };
        }
        case types.PLAYER_FINANCIAL_TRANSACTIONS_DETAILED_CHANGED: {
            return {
                ...state,
                financialTransactions: { ...state.financialTransactions, detailed: payload },
            };
        }
        case types.PLAYER_FINANCIAL_TRANSACTIONS_DETAILED_CLEARED: {
            return {
                ...state,
                financialTransactions: {
                    ...state.financialTransactions,
                    detailed: initialState.financialTransactions.detailed,
                },
            };
        }
        case types.PLAYER_FINANCIAL_TRANSACTIONS_PENDING_WITHDRAWALS_CHANGED: {
            return {
                ...state,
                financialTransactions: { ...state.financialTransactions, pendingWithdrawals: payload },
            };
        }
        case types.PLAYER_FINANCIAL_TRANSACTIONS_PENDING_WITHDRAWALS_CLEARED: {
            return {
                ...state,
                financialTransactions: {
                    ...state.financialTransactions,
                    pendingWithdrawals: initialState.financialTransactions.pendingWithdrawals,
                },
            };
        }
        case types.PLAYER_FINANCIAL_TRANSACTIONS_KPI_CHANGED: {
            return {
                ...state,
                financialTransactions: { ...state.financialTransactions, kpi: payload },
            };
        }
        case types.PLAYER_FINANCIAL_TRANSACTIONS_KPI_CLEARED: {
            return {
                ...state,
                financialTransactions: {
                    ...state.financialTransactions,
                    kpi: initialState.financialTransactions.kpi,
                },
            };
        }
        case types.PLAYER_PROFITS_AND_LOSSES_CHANGED: {
            return {
                ...state,
                playerProfitsAndLosses: payload,
            };
        }
        case types.PLAYER_PROFITS_AND_LOSSES_CLEARED: {
            return {
                ...state,
                playerProfitsAndLosses: initialState.playerProfitsAndLosses,
            };
        }
        case types.PLAYER_VERIFICATION_STATUSES_CHANGED: {
            return {
                ...state,
                playerDetails: {
                    ...state.playerDetails,
                    accountVerification: payload,
                },
            };
        }
        case types.PLAYER_COMMUNICATION_PREFERENCES_CHANGED: {
            return {
                ...state,
                playerDetails: {
                    ...state.playerDetails,
                    communicationPreferences: payload,
                },
            };
        }
        case types.PLAYER_AUTOMATIC_SEGMENT_RETURNED: {
            return {
                ...state,
                playerDetails: {
                    ...state.playerDetails,
                    isManualSegment: false,
                    segmentName: payload,
                },
            };
        }
        case types.PLAYER_DOCUMENTS_CHANGED: {
            return {
                ...state,
                documents: payload,
            };
        }
        case types.PLAYER_DOCUMENTS_CLEARED: {
            return {
                ...state,
                documents: initialState.documents,
            };
        }
        case types.PLAYER_PAYMENT_ACCOUNTS_CHANGED: {
            return {
                ...state,
                paymentAccounts: payload,
            };
        }
        case types.PLAYER_PAYMENT_ACCOUNTS_CLEARED: {
            return {
                ...state,
                paymentAccounts: initialState.paymentAccounts,
            };
        }
        case types.PLAYER_MESSAGE_THREAD_LIST_CHANGED: {
            return {
                ...state,
                communications: {
                    ...state.communications,
                    messages: {
                        ...state.communications.messages,
                        allThreads: payload,
                    },
                },
            };
        }
        case types.PLAYER_MESSAGE_THREAD_LIST_CLEARED: {
            return {
                ...state,
                communications: {
                    ...state.communications,
                    messages: {
                        ...state.communications.messages,
                        allThreads: initialState.communications.messages.allThreads,
                    },
                },
            };
        }
        case types.PLAYER_MESSAGE_THREAD_SINGLE_CHANGED: {
            return {
                ...state,
                communications: {
                    ...state.communications,
                    messages: {
                        ...state.communications.messages,
                        selectedThreads: {
                            ...state.communications.messages.selectedThreads,
                            [payload.id]: payload.data,
                        },
                    },
                },
            };
        }
        case types.PLAYER_MESSAGE_THREAD_SINGLE_CLEARED: {
            return {
                ...state,
                communications: {
                    ...state.communications,
                    messages: {
                        ...state.communications.messages,
                        selectedThreads: initialState.communications.messages.selectedThreads,
                    },
                },
            };
        }
        case types.PLAYER_MESSAGE_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                communications: {
                    ...state.communications,
                    modalProps: {
                        ...initialState.communications.modalProps,
                        ...payload,
                    },
                },
            };
        }
        case types.PLAYER_MESSAGE_MODAL_PROPS_CLEARED: {
            return {
                ...state,
                communications: {
                    ...state.communications,
                    modalProps: initialState.communications.modalProps,
                },
            };
        }

        case types.PLAYER_NOTE_LIST_CHANGED: {
            return {
                ...state,
                notes: {
                    ...state.notes,
                    list: payload,
                },
            };
        }
        case types.PLAYER_NOTE_LIST_CLEARED: {
            return {
                ...state,
                notes: {
                    ...state.notes,
                    list: initialState.notes.list,
                },
            };
        }
        case types.PLAYER_NOTE_SINGLE_CHANGED: {
            return {
                ...state,
                notes: {
                    ...state.notes,
                    selected: payload,
                },
            };
        }
        case types.PLAYER_NOTE_SINGLE_CLEARED: {
            return {
                ...state,
                notes: {
                    ...state.notes,
                    selected: initialState.notes.selected,
                },
            };
        }
        case types.PLAYER_NOTE_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                notes: {
                    ...state.notes,
                    modalProps: {
                        ...initialState.notes.modalProps,
                        ...payload,
                    },
                },
            };
        }
        case types.PLAYER_NOTE_MODAL_PROPS_CLEARED: {
            return {
                ...state,
                notes: {
                    ...state.notes,
                    modalProps: initialState.notes.modalProps,
                },
            };
        }
        case types.PLAYER_PASSWORD_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                passwordModalProps: payload,
            };
        }
        case types.PLAYER_PASSWORD_MODAL_PROPS_CLEARED: {
            return {
                ...state,
                passwordModalProps: initialState.passwordModalProps,
            };
        }
        case types.PLAYER_INFORMATION_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                informationModalProps: payload,
            };
        }
        case types.PLAYER_INFORMATION_MODAL_PROPS_CLEARED: {
            return {
                ...state,
                informationModalProps: initialState.informationModalProps,
            };
        }
        case types.PLAYER_MANUAL_PAYMENT_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                manualPaymentModalProps: payload,
            };
        }
        case types.PLAYER_MANUAL_PAYMENT_MODAL_PROPS_CLEARED: {
            return {
                ...state,
                manualPaymentModalProps: initialState.manualPaymentModalProps,
            };
        }
        case types.PLAYER_GIVE_BONUS_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                giveBonusModalProps: payload,
            };
        }
        case types.PLAYER_MANUAL_SEGMENT_MODAL_PROPS_CHANGED: {
            return {
                ...state,
                manualSegmentModalProps: payload,
            };
        }
        case types.PLAYER_MANUAL_SEGMENT_MODAL_PROPS_CLEARED: {
            return {
                ...state,
                manualSegmentModalProps: initialState.manualSegmentModalProps,
            };
        }
        case types.PLAYER_GIVE_BONUS_MODAL_PROPS_CLEARED: {
            return {
                ...state,
                giveBonusModalProps: initialState.giveBonusModalProps,
            };
        }
        case types.PLAYER_DEPOSIT_LIMITS_CHANGED: {
            return {
                ...state,
                depositLimits: payload,
            };
        }
        case types.PLAYER_SELF_EXCLUSION_CHANGED: {
            return {
                ...state,
                selfExclusion: payload,
            };
        }
        default:
            return state;
    }
};

export default player;
